/* Script to open and close predictive search */
document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth >= 750) {
    let isClosing = false;

    document.addEventListener("click", (event) => {
      if (isClosing) return;

      const expandedEl = document.querySelector(".predictive-search--expanded");
      if (!expandedEl) return;

      const clickedInside = expandedEl.contains(event.target);
      if (!clickedInside) {
        isClosing = true;
        expandedEl.classList.remove("predictive-search--expanded");

        setTimeout(() => {
          isClosing = false;
        }, 100);
      }
    });
  }
});
